var percentilesData = { medianDurationSec: 90000, percentileDurationSec: 121200 };
var percentilesStats = {
    globalStats: percentilesData,
    callbackStats: percentilesData,
    inboundStats: percentilesData,
    outboundStats: percentilesData,
};
var CompletedCallsStatsBuilder = /** @class */ (function () {
    function CompletedCallsStatsBuilder() {
        this.completedCallsStats = {
            globalCallDuration: percentilesData,
            callbackStats: { completed: 22, callDuration: percentilesData },
            inboundStats: { completed: 22, callDuration: percentilesData },
            outboundStats: { completed: 22, callDuration: percentilesData },
        };
    }
    CompletedCallsStatsBuilder.prototype.withCallDuration = function (globalCallDuration) {
        this.completedCallsStats.globalCallDuration = globalCallDuration;
        return this;
    };
    CompletedCallsStatsBuilder.prototype.withCallbackStats = function (callbackStats) {
        this.completedCallsStats.callbackStats = callbackStats;
        return this;
    };
    CompletedCallsStatsBuilder.prototype.withInboundStats = function (inboundStats) {
        this.completedCallsStats.inboundStats = inboundStats;
        return this;
    };
    CompletedCallsStatsBuilder.prototype.withOutboundStats = function (outboundStats) {
        this.completedCallsStats.outboundStats = outboundStats;
        return this;
    };
    CompletedCallsStatsBuilder.prototype.build = function () {
        return this.completedCallsStats;
    };
    return CompletedCallsStatsBuilder;
}());
export { CompletedCallsStatsBuilder };
var ShiftCallTypeStatsBuilder = /** @class */ (function () {
    function ShiftCallTypeStatsBuilder() {
        this.shiftCallTypeStats = {
            requests: 1244,
            noAnswer: 256,
            hangups: 156,
        };
    }
    ShiftCallTypeStatsBuilder.prototype.withRequests = function (requests) {
        this.shiftCallTypeStats.requests = requests;
        return this;
    };
    ShiftCallTypeStatsBuilder.prototype.withNoAnswer = function (noAnswer) {
        this.shiftCallTypeStats.noAnswer = noAnswer;
        return this;
    };
    ShiftCallTypeStatsBuilder.prototype.withHangups = function (hangups) {
        this.shiftCallTypeStats.hangups = hangups;
        return this;
    };
    ShiftCallTypeStatsBuilder.prototype.build = function () {
        return this.shiftCallTypeStats;
    };
    return ShiftCallTypeStatsBuilder;
}());
export { ShiftCallTypeStatsBuilder };
var ShiftStatsBuilder = /** @class */ (function () {
    function ShiftStatsBuilder() {
        this.shiftStats = {
            completedStats: new CompletedCallsStatsBuilder().build(),
            callbackStats: new ShiftCallTypeStatsBuilder().build(),
            inboundStats: new ShiftCallTypeStatsBuilder().build(),
            outboundStats: new ShiftCallTypeStatsBuilder().build(),
            waitDuration: percentilesStats
        };
    }
    ShiftStatsBuilder.prototype.withCompletedStats = function (completedStats) {
        this.shiftStats.completedStats = completedStats;
        return this;
    };
    ShiftStatsBuilder.prototype.withCallbackStats = function (callbackStats) {
        this.shiftStats.callbackStats = callbackStats;
        return this;
    };
    ShiftStatsBuilder.prototype.withInboundStats = function (inboundStats) {
        this.shiftStats.inboundStats = inboundStats;
        return this;
    };
    ShiftStatsBuilder.prototype.withOutboundStats = function (outboundStats) {
        this.shiftStats.outboundStats = outboundStats;
        return this;
    };
    ShiftStatsBuilder.prototype.withWaitCallDuration = function (waitDuration) {
        this.shiftStats.waitDuration = waitDuration;
        return this;
    };
    ShiftStatsBuilder.prototype.build = function () {
        return this.shiftStats;
    };
    return ShiftStatsBuilder;
}());
export { ShiftStatsBuilder };
//# sourceMappingURL=shift-stats.builder.js.map